export const FETCH_PUBLIC_SUBSCRIPTIONS_START =
  'FETCH_PUBLIC_SUBSCRIPTIONS_START';
export const FETCH_PUBLIC_SUBSCRIPTIONS_SUCCESS =
  'FETCH_PUBLIC_SUBSCRIPTIONS_SUCCESS';
export const FETCH_PUBLIC_SUBSCRIPTIONS_FAIL =
  'FETCH_PUBLIC_SUBSCRIPTIONS_FAIL';

export const RESET_SUBSCRIPTION_STORE = 'RESET_SUBSCRIPTION_STORE';

export type SubscriptionActionTypes =
  | typeof FETCH_PUBLIC_SUBSCRIPTIONS_START
  | typeof FETCH_PUBLIC_SUBSCRIPTIONS_SUCCESS
  | typeof FETCH_PUBLIC_SUBSCRIPTIONS_FAIL
  | typeof RESET_SUBSCRIPTION_STORE;
